<template>
  <el-dialog
    class="add-ca-service-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="任务类型" prop="name">
        <el-input v-model="editForm.taskType" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="任务名称" prop="name">
        <el-input v-model="editForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="参与人数" prop="number">
        <el-input v-model="editForm.number" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="任务描述" prop="description">
        <el-input
          v-model="editForm.description"
          placeholder="请输入"
          type="textarea"
          resize="none"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateTask',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    return {
      title: '新建隐私计算任务',
      dialogVisible: false,
      disabled: false,
      editForm: {
        name: '',
        number: 3,
        description: '',
        chainId: '',
        taskType: '求和场景',
        orgName: '',
        userName: ''
      },
      editRules: {
        taskType: [{ required: true, message: '请输入任务类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        number: [{ required: true, message: '请输入', trigger: 'blur' }],
        description: [{ required: true, message: '请输入任务描述', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 80
      },
      type: 'homo'
    }
  },
  methods: {
    handleCancel() {
      this.editForm = {
        name: '',
        number: 3,
        description: '',
        chainId: '',
        taskType: '求和场景',
        orgName: '',
        userName: ''
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen(type) {
      this.type = type
      this.editForm.number = type == 'homo' ? 3 : 2
      this.editForm.taskType = type == 'homo' ? '求和场景' : '数字比较'
      this.dialogVisible = true
      this.editForm.chainId = this.$store.state.computing.chainId
      let clientInfo = JSON.parse(sessionStorage.getItem('cbaas_privacy_chain_client'))
      this.editForm.userName = clientInfo.userName
      this.editForm.orgName = clientInfo.orgName
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.disabled = true
          if (this.type == 'homo') {
            this.$apis.privacy.createTask(this.editForm).then(res => {
              this.$message.success('新建隐私计算任务成功！')
              this.$emit('update:list')
              this.handleCancel()
            })
          } else {
            this.$apis.privacy.createZeroTask(this.editForm).then(res => {
              this.$message.success('新建隐私计算任务成功！')
              this.$emit('update:list')
              this.handleCancel()
            })
          }
        } else {
          this.$message.warning('请填写内容')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-ca-service-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
